<script setup lang="ts">import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  value: null
});
defineEmits(["input"]);
import { AssetSearchFilterElementDto } from '@/api';
import SIcon from '@/components/SIcon.vue';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';

const { value: facet } = __MACROS_useVModel(["value", undefined, "input"]);

const name = _computed(() => facet.value.name || '');
const icon = _computed(() => {
  switch (facet.value.icon) {
    case AssetSearchFilterElementDto.icon.TABLE_AND_VIEW:
      return 'icon-data-table';
    case AssetSearchFilterElementDto.icon.DASHBOARD:
      return 'icon-chart-multiple';
    case AssetSearchFilterElementDto.icon.PIPELINE:
      return 'icon-pipeline-orchestrator';
    case AssetSearchFilterElementDto.icon.ML_MODEL:
      return 'icon-brain-circuit';
    case AssetSearchFilterElementDto.icon.GENERIC:
      return 'icon-grid';
    default:
      return AssetSearchFilterElementDto.icon.GENERIC;
  }
});

</script>

<template lang="pug">
.asset-type.d-flex.align-center
  SIcon.asset-type-icon.mr-1(:icon="icon")
  SEllipsisTooltip(:content="name")
</template>

<style lang="scss" scoped>
.asset-type {
  margin-top: 2px;
}

.asset-type-icon {
  margin-bottom: 3px;
}
</style>
